<form [formGroup]="form">
    <ion-list class="ion-padding">
        <ion-row>
            <ion-col size="4">
                <ion-item (click)="getCountryCode()">
                    <ion-input readonly type="tel" formControlName="country_code" name="Country code" label="{{'Country' | translate}}" label-placement="floating"></ion-input>
                    <ion-icon class="caret-down-outline" slot="end" name="caret-down-outline"></ion-icon>
                </ion-item>
            </ion-col>
            <ion-col size="8">
                <ion-item>
                    <ion-input type="number" inputmode="numeric" formControlName="phone" name="Phone" label="{{'Area_Code_Phone' | translate}}" label-placement="floating"></ion-input>
                </ion-item>
            </ion-col>
        </ion-row>

        <ion-item>
            <ion-input formControlName="password" name="Password" type="password" label="{{'PASSWORD' | translate}}" label-placement="floating"></ion-input>
        </ion-item>

        <div style="height: 10px"></div>
        <ion-button type="submit" expand="block" color="primary" (click)="login()" [disabled]="isLoading || isVerifyingOtp">
            <span *ngIf="!isLoading && !isVerifyingOtp">
                <ion-icon name="log-in" class="ion-padding-end"></ion-icon>{{'LOG_IN' | translate}}
            </span>
            <ion-spinner *ngIf="isLoading || isVerifyingOtp" name="circular"></ion-spinner>
        </ion-button>
    </ion-list>
</form>